import { UNIT } from '../../constants/configuration';

const styles = {
  addressInput: {
    shadowOffset: { width: 10, height: 10 },
    shadowColor: 'black',
    shadowOpacity: 10.0,
    fontSize: UNIT
  }
};

export default styles;
